import { render } from "./AllTenderSubmissions.vue?vue&type=template&id=2c09b5ed&scoped=true"
import script from "./AllTenderSubmissions.vue?vue&type=script&lang=js"
export * from "./AllTenderSubmissions.vue?vue&type=script&lang=js"

import "./AllTenderSubmissions.vue?vue&type=style&index=0&id=2c09b5ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c09b5ed"]])

export default __exports__